import { render } from "./ToolbarItem.vue?vue&type=template&id=acb4dce2&scoped=true&ts=true"
import script from "./ToolbarItem.vue?vue&type=script&lang=ts"
export * from "./ToolbarItem.vue?vue&type=script&lang=ts"

import "./ToolbarItem.vue?vue&type=style&index=0&id=acb4dce2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/qti-player/qti-player/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acb4dce2"]])

export default __exports__